import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef } from "vue";
import { inject, onMounted, ref, watch } from "vue";
import { EmailType } from "@/model/enum/EmailType";
import { useSettingsStore } from "@/stores/SettingsStore";
import { storeToRefs } from "pinia";
import { EmailServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EmailDialog',
    props: {
        mailType: { type: String, required: true },
        orderId: { type: Number, required: true },
        attachments: { type: Array, required: false, default: () => [] },
    },
    emits: ["onDialogConfirm"],
    setup(__props, { emit: __emit }) {
        const emailService = inject(EmailServiceSymbol);
        const { settings, loadedPrivate } = storeToRefs(useSettingsStore());
        let dialog = ref(false);
        const selectedAttachments = ref([]);
        const mailContent = ref(''); // your actual data
        const editorContent = ref(''); // what the editor binds to to prevent reactive update bug with cursor position
        const props = __props;
        const emit = __emit;
        function onMailContentUpdate(value) {
            mailContent.value = value;
        }
        onMounted(() => {
            if (!loadedPrivate.value) {
                useSettingsStore().loadPrivateSettings();
            }
            emailService.getEmailTemplate(props.mailType, props.orderId).then(response => {
                mailContent.value = response.data;
                editorContent.value = response.data;
            });
        });
        watch(() => props.mailType, () => {
            emailService.getEmailTemplate(props.mailType, props.orderId).then(response => {
                mailContent.value = response.data;
                editorContent.value = response.data;
            });
        });
        function cancelDialog() {
            dialog.value = false;
            selectedAttachments.value = [];
        }
        function confirmDialog() {
            emit("onDialogConfirm", mailContent.value, selectedAttachments.value);
            dialog.value = false;
            selectedAttachments.value = [];
        }
        function getSubject() {
            const companyName = settings.value.get('company_name')?.value || '';
            switch (props.mailType) {
                case EmailType.ORDER_ACCEPTED:
                    return "Ihre Buchung bei " + companyName + " ist eingegangen";
                case EmailType.ORDER_DECLINED:
                    return "Ihre Anfrage bei " + companyName + " kann leider nicht mehr bedient werden";
                case EmailType.ORDER_CHANGED:
                    return '[Rechnungsnummer] - Ihre Buchung bei ' + companyName + ' wurde geändert';
                case EmailType.ORDER_CANCELLED:
                    return '[Rechnungsnummer] - Ihre Buchung bei ' + companyName + ' wurde storniert';
            }
        }
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_VuetifyTiptap = _resolveComponent("VuetifyTiptap");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                modelValue: _unref(dialog),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
                width: "unset",
                "min-width": "800"
            }, {
                activator: _withCtx(({ props }) => [
                    _renderSlot(_ctx.$slots, "activator", { props: props })
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode("Email versenden")
                                ])),
                                _: 1
                            }),
                            (_unref(loadedPrivate))
                                ? (_openBlock(), _createBlock(_component_v_container, {
                                    key: 0,
                                    class: "d-flex flex-wrap"
                                }, {
                                    default: _withCtx(() => [
                                        (__props.attachments.length > 0)
                                            ? (_openBlock(), _createBlock(_component_v_card, {
                                                key: 0,
                                                class: "mr-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_card_title, null, {
                                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                            _createTextVNode("Anhänge")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attachments, (attachment, index) => {
                                                        return (_openBlock(), _createBlock(_component_v_checkbox, {
                                                            class: "px-4",
                                                            key: index,
                                                            label: attachment,
                                                            modelValue: selectedAttachments.value,
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedAttachments).value = $event)),
                                                            value: attachment,
                                                            "hide-details": true,
                                                            density: "compact"
                                                        }, null, 8, ["label", "modelValue", "value"]));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_v_card, { class: "pa-0 flex-grow-1" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_container, { class: "d-flex py-2 text-grey" }, {
                                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                        _createTextVNode(" An: [Email des Kunden] ")
                                                    ])),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_divider),
                                                _createVNode(_component_v_container, { class: "d-flex py-2 text-grey" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" Betreff: " + _toDisplayString(getSubject()), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_divider),
                                                _createVNode(_component_VuetifyTiptap, {
                                                    "model-value": editorContent.value,
                                                    "onUpdate:modelValue": onMailContentUpdate,
                                                    "hide-toolbar": "",
                                                    "hide-bubble": ""
                                                }, {
                                                    bottom: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "ma-0 pa-0" })
                                                    ]),
                                                    _: 1
                                                }, 8, ["model-value"]),
                                                _createVNode(_component_v_divider),
                                                _createVNode(_component_v_container, { class: "text-grey pa-2" }, {
                                                    default: _withCtx(() => [
                                                        (selectedAttachments.value.length > 0)
                                                            ? (_openBlock(), _createBlock(_component_v_container, {
                                                                key: 0,
                                                                class: "pa-0"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { class: "" }, {
                                                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                                            _createTextVNode("mdi-paperclip")
                                                                        ])),
                                                                        _: 1
                                                                    }),
                                                                    _createTextVNode(" " + _toDisplayString(selectedAttachments.value.join(', ')), 1)
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_v_container, { class: "pa-2 text-caption" }, {
                                                            default: _withCtx(() => [
                                                                _renderSlot(_ctx.$slots, "attachementNote")
                                                            ]),
                                                            _: 3
                                                        })
                                                    ]),
                                                    _: 3
                                                })
                                            ]),
                                            _: 3
                                        })
                                    ]),
                                    _: 3
                                }))
                                : _createCommentVNode("", true),
                            _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, { onClick: cancelDialog }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("Abbrechen")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_btn, { onClick: confirmDialog }, {
                                        default: _withCtx(() => [
                                            _renderSlot(_ctx.$slots, "confirmBtnText")
                                        ]),
                                        _: 3
                                    })
                                ]),
                                _: 3
                            })
                        ]),
                        _: 3
                    })
                ]),
                _: 3
            }, 8, ["modelValue"]));
        };
    }
});
